export default "__VITE_ASSET__3e04439d__"